import { ReactNode, useId, useRef } from "react";
import { BoundaryContext, FloatingPanelMenu, TextMenuItem } from "@pjs/core-ui";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { Avatar } from "../avatar/Avatar.component";
import { IAccountMenuDropdownProps } from "./interfaces/IAccountMenuDropdownProps";
import "./styles/account-menu-dropdown.css";

export function AccountMenuDropdown(props: IAccountMenuDropdownProps): ReactNode {
    const elementRef = useRef<HTMLElement>(document.body);
    const triggerId = useId();

    return (
        <BoundaryContext.Provider value={{ element: elementRef }}>
            <FloatingPanelMenu placement={"bottom-end"} items={props.accountMenuButtons}>
                <FloatingPanelMenu.Trigger
                    ariaLabel={userUiI18n.getString("account_settings_menu.a11y.trigger.label")}
                    id={triggerId}
                    className="uui-account-menu-dropdown__trigger"
                    activeClass="uui-account-menu-dropdown__trigger--active"
                    dataHook={"account-menu-button"}>
                    <Avatar className="uui-account-menu-dropdown__img" src={props.accountMenuData.profilePic} />
                </FloatingPanelMenu.Trigger>
                <FloatingPanelMenu.Panel>
                    <div className="uui-account-menu-dropdown__header">
                        <Avatar className="uui-account-menu-dropdown__img-header" src={props.accountMenuData.profilePic} />
                        <div className="uui-account-menu-dropdown__info">
                            <div className="uui-account-menu-dropdown__text">
                                {props.accountMenuData.firstname} {props.accountMenuData.lastname}
                            </div>
                            <div className="uui-account-menu-dropdown__sub-text">{props.accountMenuData.organisation}</div>
                        </div>
                    </div>
                    <FloatingPanelMenu.Menu dataHook={"account-menu-content"} renderer={TextMenuItem} ariaLabelledBy={triggerId} />
                </FloatingPanelMenu.Panel>
            </FloatingPanelMenu>
        </BoundaryContext.Provider>
    );
}
